import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { selectPreview } from 'entities/user-interface/reducer';
import { StyleShape } from 'entities/step-children/shape';
import { BlockContentShape } from 'entities/block/shape';
import { ERROR_COLOR, ERROR_MESSAGE, INPUT_COLOR } from 'lib/user-interface';
import { COLOR_MODES } from 'lib/user-preferences';
import transformStyles from 'components/Editor/Primitives/transform-styles';
import TextContainer from 'components/Editor/Containers/TextContainer';
import TextField from './TextField';
import handleErrorStyle from './error-style-handler';
import ErrorMessage from './ErrorMessage';

const TextInputContainer = styled.div``;

const TextInput = ({
  id,
  label,
  placeholder,
  numberOfLines,
  required,
  errorLabel,
  textFieldStyle,
  style,
  colorMode,
  selectedPreview,
}) => {
  const styles = transformStyles(style, colorMode);

  const {
    [ERROR_COLOR]: previewErrorColor,
    [ERROR_MESSAGE]: previewErrorMessage,
    [INPUT_COLOR]: previewInputColor,
  } = selectedPreview(id);

  const { id: labelId, text: labelText, spans, style: labelStyle } = label;
  const { text: errorMessage, style: errorStyle } = errorLabel ?? {};
  const { color: errorColor, ...errorStyles } = transformStyles(
    errorStyle,
    colorMode
  );

  const labelStyles = previewErrorColor
    ? handleErrorStyle({ style: labelStyle, color: errorColor })
    : labelStyle;

  return (
    <TextInputContainer id={id} style={styles}>
      <TextContainer
        id={labelId}
        text={labelText}
        spans={spans}
        label={{
          errorColor: labelStyles.color,
          required,
        }}
        style={labelStyles}
        colorMode={colorMode}
      />
      <TextField
        id={id}
        placeholder={placeholder}
        numberOfLines={numberOfLines}
        textFieldStyle={textFieldStyle}
        previewInputColor={previewInputColor}
        error={{ previewErrorColor, errorColor }}
        colorMode={colorMode}
      />
      {required && previewErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          color={errorColor}
          transformedStyle={errorStyles}
        />
      )}
    </TextInputContainer>
  );
};

TextInput.propTypes = {
  id: PropTypes.string,
  label: BlockContentShape,
  placeholder: BlockContentShape,
  numberOfLines: PropTypes.number,
  required: PropTypes.bool,
  errorLabel: BlockContentShape,
  textFieldStyle: StyleShape,
  style: StyleShape,
  colorMode: PropTypes.oneOf(COLOR_MODES),
  selectedPreview: PropTypes.func,
};

const mapStateToProps = state => ({
  selectedPreview: blockId => selectPreview(state, blockId),
});

export default connect(mapStateToProps)(TextInput);
